import './featured-collections.scss';
